import React, { Component } from "react";
import { Table, Pagination, Col, Row, Button } from "antd";
import moment from "moment";
import { strings } from "../../../helpers";

export default class AdminsView extends Component {
  render() {
    const {
      adminsList,
      toggleModal,
      handleDelete,
      handleEdit,
      totalRecords,
      pageNo,
      perPage,
      onPageChange
    } = this.props;
    const columns = [
      {
        title: "Name",
        dataIndex: "name",
        align: "left"
      },

      {
        title: "Mobile Number",
        dataIndex: "phone_number",
        key: "phone_number",
        align: "left"
      },
      {
        title: "Email",
        dataIndex: "email",
        align: "left"
      },
      {
        title: "Status",
        dataIndex: "status",

        align: "left"
      },
      {
        title: "Action",

        key: "actions",
        align: "left",
        render: record => (
          <div>
            {/* {
              <Button
                type="default"
                shape="circle"
                icon="edit"
                className="mr-10"
                onClick={() => handleEdit(record)}
              />
            } */}
            {
              <Button
                type="default"
                shape="circle"
                icon="delete"
                className="mr-10"
                onClick={() => handleDelete(record)}
              />
            }
          </div>
        )
      }
    ];

    return (
      <div className="content-container">
        <div className="backgroundWhite">
          <Row type="flex" justify="space-between" align="middle">
            <Col span={5} className="heading-domain">
              Admins
            </Col>
            <Col>
              <Button type="primary" onClick={toggleModal}>
                Create admin
              </Button>
            </Col>
          </Row>

          <div className="mt-20 kc-block white-bg round-borders-4x">
            <Table
              columns={columns}
              dataSource={adminsList}
              pagination={false}
              rowKey="id"
            />
          </div>
          {totalRecords > perPage && (
            <Pagination
              className="mt-10"
              total={totalRecords}
              current={pageNo}
              onChange={onPageChange}
              pageSize={perPage}
              defaultCurrent={pageNo}
            />
          )}
        </div>
      </div>
    );
  }
}
